import { render, staticRenderFns } from "./SimilarProposals.vue?vue&type=template&id=745fd482&scoped=true&"
import script from "./SimilarProposals.vue?vue&type=script&lang=js&"
export * from "./SimilarProposals.vue?vue&type=script&lang=js&"
import style0 from "./SimilarProposals.vue?vue&type=style&index=0&id=745fd482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745fd482",
  null
  
)

export default component.exports